const adyenLocaleFallbacks = {
    'bg-BG': 'en-US',
    'de-AT': 'de-DE',
    'de-CH': 'de-DE',
    en: 'en-US',
    'en-GB': 'en-US',
    'en-IE': 'en-US',
    'fr-BE': 'fr-FR',
    'fr-CH': 'fr-FR',
    'nb-NO': 'no-NO',
    zu: 'en-US',
};
// same locale for us and for Adyen: cs-CZ, da-DK, el-GR, es-ES, fi-FI, fr-FR, hr-HR, hu-HU, it-IT, nl-NL, pl-PL, pt-PT, ro-RO, ru-RU, sk-SK, sl-SI, sv-SE
function normalizeLocaleForAdyen(locale) {
    const adyenLocale = adyenLocaleFallbacks[locale];
    return adyenLocale ?? locale;
}

export { normalizeLocaleForAdyen };
//# sourceMappingURL=Adyen.static.js.map
